import React, { FC, ReactNode, useState } from 'react';
import { PrepRequestType } from 'models/prep-request.model';
import { PrepTeamRequestContext } from './context';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
const PrepTeamRequestProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [itemRequestToEdit, setItemRequestToEdit] = useState<PrepRequestType>({
    id: '',
    item_type: '',
    code: 0,
    note: '',
    status: ENUM_REQUEST_STATUS.PENDING,
    created_at: '',
    updated_at: '',
    user_id: '',
    store_id: '',
    items: []
  });
  return (
    <PrepTeamRequestContext.Provider
      value={{
        itemRequestToEdit,
        setItemRequestToEdit
      }}>
      {children}
    </PrepTeamRequestContext.Provider>
  );
};

export default PrepTeamRequestProvider;
